
import { defineComponent, PropType } from 'vue'

import FtlOrderStockDeliveryNote from '../FtlOrderStockDeliveryNote/index.vue'
import FtlAdditionalService from '../FtlAdditionalService/index.vue'

import { StockDeliveryNoteT } from '@/core/types/orders.types'
import { AdditionalServicesFTLI } from '@/core/types/additional_services.types'
import Cheap from '@/common/components/UI/Cheap/index.vue'

export default defineComponent({
    components: {
        FtlOrderStockDeliveryNote,
        FtlAdditionalService,
        Cheap,
    },
    props: {
        additionalService: {
            type: Array as PropType<AdditionalServicesFTLI[]>,
            default: () => [],
        },
        sender: {
            type: Object,
            default: null,
        },
        stockDeliveryNotes: {
            type: Array as PropType<StockDeliveryNoteT[]>,
            default: () => [],
        },
        isUploadingScan: {
            type: Boolean,
            default: false,
        },
        isPrintingInvoice: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['upload-scan', 'print-invoice'],
    setup(props, { emit }) {
        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '-'
        }

        const onUploadScan = (stockDeliveryNote: StockDeliveryNoteT) => {
            if (props.isUploadingScan) return
            emit('upload-scan', stockDeliveryNote)
        }

        const onPrintInvoice = (index: number) => {
            if (props.isPrintingInvoice) return
            emit('print-invoice', index)
        }

        return {
            formatAmount,
            onUploadScan,
            onPrintInvoice,
        }
    },
})
